"use client";
import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { input, textLabel, focusIndicator, slider } from './styles.js';
import { Box } from '../Box/Box.web.js';
import { ThemeProvider } from 'styled-components';
import { IconLocked } from '../icons/ui_general/IconLocked.web.js';
import { useTheme } from '../utils/theming/useTheme.js';
import { px2rem } from '../utils/helpers/style.js';

var _excluded = ["id", "name", "onChange", "value", "checked", "disabled", "label", "color", "inputProps", "variant", "locked", "onFocus", "onBlur"];
var LockedToggleIcon = function LockedToggleIcon(props) {
  var variant = props.variant,
    checked = props.checked,
    disabled = props.disabled,
    testID = props['data-testid'];
  var theme = useTheme();
  return /*#__PURE__*/React.createElement(IconLocked, {
    "data-testid": testID,
    size: variant === 'condensed' ? 16 : 20,
    top: px2rem(variant === 'condensed' ? 4 : 6),
    left: px2rem(checked ? variant === 'condensed' ? 6 : 9 : variant === 'condensed' ? 24 : 34),
    color:
    // istanbul ignore next -- too much complexity to tests
    disabled ? theme.toggle.web.slider.colors.disabled : theme.toggle.web.slider.colors["default"],
    position: "absolute",
    style: {
      pointerEvents: 'none'
    }
  });
};
var Toggle = function Toggle(_ref) {
  var id = _ref.id,
    name = _ref.name,
    onChange = _ref.onChange,
    value = _ref.value,
    checked = _ref.checked,
    disabled = _ref.disabled,
    label = _ref.label,
    colorProp = _ref.color,
    inputProps = _ref.inputProps,
    variantProp = _ref.variant,
    _ref$locked = _ref.locked,
    locked = _ref$locked === undefined ? false : _ref$locked,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    props = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  var toggleTheme = theme.toggle.web;
  var color = colorProp || toggleTheme.color;
  var variant = variantProp || theme.variant;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(Box, _extends({
    tag: "label",
    display: "inline-block",
    position: "relative",
    "data-testid": "elemental-Toggle-".concat(id || name)
  }, props), /*#__PURE__*/React.createElement(input, _extends({
    type: "checkbox",
    $color: color,
    "data-testid": "elemental-Toggle-".concat(id || name, "-input"),
    id: id,
    name: name,
    value: value,
    $variant: variant,
    onChange: onChange,
    checked: checked,
    $locked: locked,
    disabled: locked || disabled,
    onFocus: onFocus,
    onBlur: onBlur
  }, inputProps)), /*#__PURE__*/React.createElement(textLabel, {
    $variant: variant
  }, label), /*#__PURE__*/React.createElement(focusIndicator, {
    $color: color,
    $variant: variant
  }), /*#__PURE__*/React.createElement(slider, {
    $color: color,
    $variant: variant
  }), locked && /*#__PURE__*/React.createElement(LockedToggleIcon, {
    "data-testid": "elemental-Toggle-".concat(id || name, "-LockedToggleIcon"),
    variant: variant,
    checked: checked,
    disabled: disabled
  })));
};

export { Toggle };
